// Conferências do Novo Pedido do Delivery feitas na tela, antes do "Criar"
// (30/09/2026): endereço completo já na etapa Entrega e troco que cobre o total.

const semAcento = (s) => String(s || "").trim().toLowerCase();

/** Bairro do endereço na lista de bairros da loja (o que dá a taxa), ou null. */
export function bairroCadastrado(bairro, bairros) {
  const alvo = semAcento(bairro);
  if (!alvo) return null;
  return (bairros || []).find((b) => semAcento(b.nome || b.name) === alvo) || null;
}

/**
 * O que falta no endereço de entrega para o pedido poder ser criado:
 * lista de textos ("número", "bairro", "bairro X não está cadastrado").
 * Vazia = pode seguir.
 */
export function faltasDoEndereco(endereco, bairros) {
  const faltas = [];
  if (!String(endereco?.rua || "").trim()) faltas.push("rua");
  if (!String(endereco?.numero || "").trim()) faltas.push("número");
  if (!String(endereco?.bairro || "").trim()) faltas.push("bairro");
  else if (!bairroCadastrado(endereco.bairro, bairros)) faltas.push(`bairro "${String(endereco.bairro).trim()}" não está cadastrado em Bairros`);
  return faltas;
}

/** Troco para um valor menor que o total não serve (o cliente paga menos que o pedido). */
export function trocoAbaixoDoTotal(trocoPara, total) {
  if (trocoPara === "" || trocoPara == null) return false;
  const v = parseFloat(String(trocoPara).replace(",", "."));
  return Number.isFinite(v) && Math.round(v * 100) < Math.round((Number(total) || 0) * 100);
}
